import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Role } from '@compumark/order-management-client';
import { Subscription } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../security/services/authentication.service';
import { UserService } from '../../security/services/user.service';

@Component({
  selector: 'app-clarivate-header',
  templateUrl: './clarivate-header.component.html',
  styleUrls: ['./clarivate-header.component.scss'],
  standalone: false,
})
export class ClarivateHeaderComponent {
  private userService = inject(UserService);
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);

  subscription: Subscription | undefined;
  userName: string | undefined;
  showHeader: boolean | undefined;
  isProduction = environment.production;
  isAdminUser = false;
  constructor() {
    this.userService.getCurrentUserObservable().subscribe((user) => {
      setTimeout(() => {
        this.userName = user.name;
        this.isAdminUser = this.isAdmin();
      });
    });
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url.includes('order-management/fulltext/')) {
          this.showHeader = false;
        } else {
          this.showHeader = true;
        }
      }
    });
  }
  isAdmin(): boolean {
    return (
      !!this.userService.getCurrentUser() &&
      !!this.userService
        .getCurrentUser()
        .authorities?.find((r) => r.authority === Role.ADMIN)
    );
  }

  logout(): void {
    this.authenticationService.logout();
  }
}
